class HeroOffer extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      copyButton: this.querySelector('.js-copy-btn'),
      codeElement: this.querySelector('.js-promo-code'),
      copyMessage: this.querySelector('.js-copy-message'),
      videoToggle: this.querySelector('.js-video-toggle'),
      videoContainer: this.querySelector('.hero-offer__media-video'),
      videoPoster: this.querySelector('.hero-offer__media-poster'),
    };

    if (this.elements.copyButton) {
      this.elements.copyButton.addEventListener('click', this.handleCopy.bind(this));
    }

    if (this.elements.videoToggle) {
      this.elements.videoToggle.addEventListener('click', this.handleVideoLoad.bind(this));
    }
  }

  handleCopy(event) {
    event.preventDefault();
    const code = this.elements.codeElement.value || this.elements.codeElement.textContent.trim();
    
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(() => {
        this.showCopySuccess();
      }).catch(err => {
        console.error('Failed to copy:', err);
        this.fallbackCopy(code);
      });
    } else {
      this.fallbackCopy(code);
    }
  }

  fallbackCopy(code) {
    // Fallback for older browsers or if clipboard API is blocked
    try {
      const textarea = document.createElement('textarea');
      textarea.value = code;
      textarea.style.position = 'fixed'; // Avoid scrolling to bottom
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      this.showCopySuccess();
    } catch (err) {
      console.error('Fallback copy failed', err);
      // Ideally show a message telling user to manually copy
      if(this.elements.copyMessage) {
        this.elements.copyMessage.textContent = 'Press Ctrl+C to copy';
        this.elements.copyMessage.hidden = false;
        setTimeout(() => this.elements.copyMessage.hidden = true, 3000);
      }
    }
  }

  showCopySuccess() {
    if (!this.elements.copyMessage) return;
    
    const originalText = this.elements.copyMessage.dataset.originalText || 'Copied!';
    this.elements.copyMessage.textContent = originalText;
    this.elements.copyMessage.hidden = false;
    this.elements.copyMessage.setAttribute('aria-hidden', 'false');

    setTimeout(() => {
      this.elements.copyMessage.hidden = true;
      this.elements.copyMessage.setAttribute('aria-hidden', 'true');
    }, 3000);
  }

  handleVideoLoad() {
    if (!this.elements.videoContainer) return;
    
    const template = this.elements.videoContainer.querySelector('template');
    if (template) {
      const videoContent = template.content.cloneNode(true);
      this.elements.videoContainer.innerHTML = '';
      this.elements.videoContainer.appendChild(videoContent);
      this.elements.videoContainer.hidden = false;
      if (this.elements.videoPoster) {
        this.elements.videoPoster.hidden = true;
      }
    }
  }
}

customElements.define('hero-offer', HeroOffer);
